import { AgeGroup, Gender } from "@/services/graphql/generated";
import { useSearchParams } from "next/navigation";

export interface MediaFilterParams {
  targetCategories?: string;
  adFeePerMonth?: number;
  trafficValue?: number;
  adTypes?: string;
  inGender?: Gender[];
  inAge?: AgeGroup[];
}

export function useMediaFilterParams(): MediaFilterParams {
  const searchParams = useSearchParams();

  const targetCategories = searchParams?.get("target_categories") || undefined;
  const adFeePerMonth = searchParams?.get("b") ? Number(searchParams.get("b")) : undefined;
  const trafficValue = searchParams?.get("traffic") ? Number(searchParams.get("traffic")) : undefined;
  const adTypes = searchParams?.get("ad_type") || undefined;
  const inGender = searchParams?.get("gender")?.split(",").filter(Boolean) as Gender[] | undefined;
  const inAge = searchParams?.get("age_group")?.split(",").filter(Boolean) as AgeGroup[] | undefined;

  return {
    targetCategories,
    adFeePerMonth,
    trafficValue,
    adTypes,
    inGender,
    inAge,
  };
}
